<template>
  <div id="channelQrCode">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" type="text" v-model="searchData.channelName" placeholder="渠道名">
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="categoryList" :needReturn="'id'" :placeholder="'分类'" :matchValue="'name'" :showValue="'{{name}}'" v-model="searchData.categoryId">
              </allSelect>
            </abbr>
          </p>
          <button class="redButton" @click="getQrCodeList(1)">搜索</button>
        </div>
        <div style="width: auto">
          <button class="redButtonTwo" @click="addNewCode">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th class="t_c">ID</th>
            <th class="t_c">分类</th>
            <th class="t_c">渠道名</th>
            <th class="t_c">创建日期</th>
            <th class="t_c">创建人</th>
            <th class="t_c">操作</th>
          </tr>
          </thead>
          <tbody>
            <template v-if="qrCodeList.length > 0">
              <tr :key="index" v-for="(item, index) in qrCodeList">
                <td width="10%" class="t_c NoWrap">{{item.id}}</td>
                <td width="15%" class="t_c NoWrap">{{item.categoryName}}</td>
                <td width="20%" class="t_c NoWrap">{{item.name}}</td>
                <td width="20%" class="t_c NoWrap">{{item.createTime}}</td>
                <td width="15%" class="t_c NoWrap">{{item.createName}}</td>
                <td width="20%" class="t_c">
                  <div class="icon more iconfont icongengduo moreOperations">
                    <ul>
                      <li @click="checkQrCode(item)">查看</li>
                      <li @click="downloadQrCode(item)">下载</li>
                      <li v-if="userInfo.id == item.createId" @click="editQrCode(item)">编辑</li>
                      <li v-if="userInfo.id == item.createId" @click="deleteQrCode(item)">禁用</li>
                      <li @click="checkHistory(item)">查看历史</li>
                    </ul>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="6">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getQrCodeList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!-- <div class="main-container">
      <ul>
        <li v-for="(item, index) in qrCodeList" :key="index">
          <div class="item-code" :style="item.img ? '' : 'border: 1px solid #C5C5C5;'">
            <img v-if="item.img" :src="item.img" alt="">
          </div>
          <div class="item-name">{{item.name}}</div>
          <div class="item-download" @click="downloadQrCode(item)">下载</div>
        </li>
        <li @click="addNewCode">
          <div class="item-code addNew">
            <div class="horizontal-line"></div>
            <div class="vertical-line"></div>
          </div>
        </li>
      </ul>
    </div> -->
    <!-- 新增/编辑 -->
    <model v-if="showModel" :buttonType="0" :title="modalTitle" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>渠道名称</span>
            <input maxlength="50" v-model="modalData.name" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入名称" />
          </li>
          <li style="margin-bottom: 50px;">
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>分类</span>
            <span style="width: calc(100% - 98px); margin-left: -30px;">
              <allSelect :width="302" :chooseData="categoryListNew" :needReturn="'id'" :placeholder="'分类'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modalData.categoryId">
              </allSelect>
            </span>
          </li>
        </ul>
      </div>
    </model>
    <!-- 查看 -->
    <model v-if="showQrCodeModal" :buttonType="3" title="查看二维码" :minWidth="'500px'" v-on:on-cancel="cancelQrCodeModal()" v-on:on-confirm="confirmQrCodeModal()">
      <div style="width:60%;margin: 10px auto;">
        <div class="qrcode-name">{{QrCodeModalData.name}}</div>
        <div class="qrcode">
          <img class="qrcode-img" :src="QrCodeModalData.img" alt="">
        </div>
        <div class="item-download" @click="downloadQrCode(QrCodeModalData)">下载</div>
      </div>
    </model>
    <!-- 查看历史 -->
    <model v-if="showHistoryModal" :buttonType="3" title="查看历史" :minWidth="'800px'" v-on:on-cancel="cancelHistoryModal()" v-on:on-confirm="confirmHistoryModal()">
      <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable alltableHui">
          <thead>
          <tr>
            <th class="t_c">渠道名</th>
            <th class="t_c">分类</th>
            <th class="t_c">修改日期</th>
            <th class="t_c">修改人</th>
          </tr>
          </thead>
          <tbody>
            <template v-if="historyList.length > 0">
              <tr :key="index" v-for="(item, index) in historyList">
                <td width="25%" class="t_c NoWrap" style="max-width:180px;" :title="item.channelQRName">{{item.channelQRName}}</td>
                <td width="25%" class="t_c NoWrap" :title="item.categoryName">{{item.categoryName}}</td>
                <td width="25%" class="t_c NoWrap">{{item.updateTime}}</td>
                <td width="25%" class="t_c NoWrap">{{item.updateName}}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="3">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="historyTotalPage !== 0" :totalCount="historyTotalCount" v-on:on-getList="getHistoryList($event)" :totalPage="historyTotalPage" :page="historyPage" :explain="0"></page>
    </div>
    </model>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'channelQrCode',
  data () {
    return {
      searchData: {
        channelName: '',
        categoryId: '',
      },
      categoryList: [],
      categoryListNew: [],
      qrCodeList: [],
      page: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 10,
      showModel: false,
      modalTitle: '',
      modalData: {
        id: '',
        name: '',
        categoryId: ''
      },
      showQrCodeModal: false,
      QrCodeModalData: {
        img: '',
        name: ''
      },
      showHistoryModal: false,
      historyList: [],
      historyPage: 1,
      historyTotalPage: 0,
      historyTotalCount: 0,
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')) || {},
      currentCode: {}
    }
  },
  created () {
    // 获取二维码列表
    this.getQrCodeList(1)
    // 获取分类
    this.getAllCategory()
  },
  mounted () {

  },
  methods: {
    // 获取二维码列表
    getQrCodeList (page) {
      this.page = page
      this.$axiox.get(`/api/ChannelQRCode/QueryChannelQRCode?channelName=${this.searchData.channelName}&categoryId=${this.searchData.categoryId}&PageIndex=${page}&PageSize=${this.pageSize}`).then(res => {
        console.log(res, 'getQrCodeList')
        if (res.data && res.data.length > 0) {
          this.qrCodeList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.qrCodeList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
    },
    addNewCode () {
      this.modalTitle = '新增二维码'
      this.showModel = true
    },
    confirModel () {
      if (this.modalData.id) {
        // 编辑
        this.modalData.name = this.modalData.name.trim()
        if (!this.modalData.name || !this.modalData.categoryId ) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return
        }
        // 如果名称和分类没有修改，则不调接口
        if (this.modalData.categoryId == this.currentCode.categoryId && this.modalData.name == this.currentCode.name) {
          this.modalTitle = ''
          this.modalData.id = ''
          this.modalData.name = ''
          this.modalData.categoryId = ''
          this.showModel = false
          return
        }
        this.$axiox.put(`/api/ChannelQRCode/UpdateChannelQR?channelName=${this.modalData.name}&categoryId=${this.modalData.categoryId}&Id=${this.modalData.id}`).then(res => {
          console.log(res, 'UpdateChannelQR')
          this.modalTitle = ''
          this.modalData.id = ''
          this.modalData.name = ''
          this.modalData.categoryId = ''
          this.showModel = false
          this.getQrCodeList(1)
        })
      } else {
        // 新增
        this.modalData.name = this.modalData.name.trim()
        if (!this.modalData.name || !this.modalData.categoryId ) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return
        }
        this.$axiox.post(`/api/ChannelQRCode/AddChannelQR?channelName=${this.modalData.name}&categoryId=${this.modalData.categoryId}`).then(res => {
          console.log(res, 'confirModel')
          if (res) {
            this.modalTitle = ''
            this.modalData.id = ''
            this.modalData.name = ''
            this.modalData.categoryId = ''
            this.showModel = false
            this.getQrCodeList(1)
          }
        })
      }
    },
    cancelModel () {
      this.modalTitle = ''
      this.modalData.id = ''
      this.modalData.name = ''
      this.modalData.categoryId = ''
      this.showModel = false
    },
    // 下载
    downloadQrCode (item) {
      // 下载二进制流图片
      // responseType: "arraybuffer"
      axios.get(`/api/ChannelQRCode/Download?id=${item.id}`, {responseType: "arraybuffer"}).then(res => {
        let src = 'data:image/png;base64,'+ window.btoa(
          new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        )
        let link = document.createElement('a')
        link.href = src
        link.download = (item.name ? item.name : 'qrCode') + '.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err, 'err')
      })
    },
    // 编辑
    editQrCode (item) {
      this.modalTitle = '编辑二维码'
      this.modalData.id = item.id
      this.modalData.name = item.name
      this.modalData.categoryId = item.categoryId
      this.showModel = true
      this.currentCode = item
    },
    // 查看
    checkQrCode (item) {
      this.QrCodeModalData = JSON.parse(JSON.stringify(item))
      this.showQrCodeModal = true
    },
    confirmQrCodeModal () {
      this.QrCodeModalData = {}
      this.showQrCodeModal = false
    },
    cancelQrCodeModal () {
      this.QrCodeModalData = {}
      this.showQrCodeModal = false
    },
    // 删除
    deleteQrCode (item) {
      this.$commonJs.doubleComfirm({
        content: '您是否确认禁用？',
        successFun: () => {
          this.$axiox.del(`/api/ChannelQRCode/Delete/${item.id}`).then(res => {
            console.log(res, 'Delete')
            if (res == 'True') {
              this.getQrCodeList(1)
            }
          })
        },
        errorFun: err => {
        }
      })
    },
    // 查看历史
    checkHistory (item) {
      // this.getHistoryList(item.id)
      this.showHistoryModal = true
      this.$axiox.get(`api/ChannelQRCode/ChannelQREditLog/${item.id}`).then(res => {
        console.log(res, 'ChannelQREditLog​')
        this.historyList = res
      })
    },
    confirmHistoryModal () {
      this.showHistoryModal = false
    },
    cancelHistoryModal () {
      this.showHistoryModal = false
    },
    getHistoryList (id) {
      // this.historyPage = page
      this.$axiox.get(`​/api​/ChannelQRCode​/ChannelQREditLog/${id}`).then(res => {
        console.log(res, 'ChannelQREditLog​')
      })
    },
    // 获取分类
    getAllCategory () {
      this.$axiox.get(`/api/ChannelQRCode/GetAllCategory`).then(res => {
        console.log(res, '获取分类')
        if (res && res.length > 0) {
          this.categoryList = [
            {id: 0, name: '全部'},
            ...res
          ]
          this.categoryListNew = res
        } else {
          this.categoryList = []
          this.categoryListNew = []
        }
      })
    }
  }
}
</script>
<style scoped>
  .main-container {
   width: 100%;
   /* height: 100%; */
  }
  .main-container {
    padding-top: 80px;
    padding-right: 3.5vw;
    padding-bottom: 50px;
    box-sizing: border-box;
  }
  .main-container ul {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .main-container ul li {
    float: left;
    margin-left: 3.4vw;
    margin-bottom: 30px;
  }
  .main-container ul li .item-code {
    width: 12vw;
    height: 12vw;
    text-align: center;

  }
  .main-container ul li .item-code img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .addNew {
    border: 1px dashed #C5C5C5!important;
    position: relative;
    cursor: pointer;
  }
  .horizontal-line {
    position: absolute;
    width: 80px;
    height: 0.85px;
    background-color:#C5C5C5;
    margin:0 auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .vertical-line {
    position: absolute;
    width: 0.3px;
    height:80px;
    background-color:#C5C5C5;
    margin:0 auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .item-name {
    text-align: center;
    font-size: 16px;
    margin: 10px auto;
  }
  .item-download {
    padding: 2px 15px;
    color: #EF1201;
    border: 1px solid #EF1201;
    border-radius: 4px;
    text-align: center;
    width: 70px;
    margin: 0 auto;
    box-sizing: border-box;
    cursor: pointer;
    margin-top: 15px;
  }
  .qrcode {
    width: 100%;
    text-align: center;
  }
  .qrcode-img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .qrcode-name {
    margin-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/qrCodeManager/channelQrCode.vue